import React from 'react';
import {Grid} from "@mui/material";
import {Theme, styled} from "@mui/system";
import {WarningLevelType} from "./types";

const Root = styled(Grid, {
  shouldForwardProp: (prop) => (
    prop !== 'warningLevel'
  )
})(({theme, warningLevel}: {
  theme: Theme,
  warningLevel?: WarningLevelType
}) => ({
  backgroundColor: (warningLevel && warningLevel !== 'none') ? theme.palette[warningLevel].light : "rgba(63, 81, 181, 0.08)",
  padding: "0.94em 0.71em",
}));

type CardHeaderContainerWarningAdditionalProps = React.ComponentPropsWithoutRef<'div'> & {
  theme?: Theme,
  warningLevel?: WarningLevelType
}

/**
 * MUI Grid component styled in the SecurSpace way. Used in the main Container for styling the header items
 * @param children children passed through to the internal Grid component
 * @param warningLevel tells the container which background color to use
 * @param rest The rest of the container props that will be passed through to the internal Grid component
 * @constructor
 */
const CardHeaderContainerWarning = ({ children, ...rest}: CardHeaderContainerWarningAdditionalProps) => {
  return <Root container justifyContent={'space-between'} alignItems={'center'} gap={2} {...rest}>
    { children }
  </Root>
}

export { CardHeaderContainerWarning };
